export default __webpack_public_path__ + "static/media/sanatanAd.ec4aa10fdc45cafefeb65dcddc15d379.webp";